<template>
    <div>
        <h2>Documents</h2>
        <table class="table table-bordered">
            <tbody>
            <tr v-for="(file, index) in files">
                <td>
                    <input type="hidden" :name="'files[' + file.index + '][id]'" v-model="file.id">
                    <input type="file" :name="'files[' + file.index + '][document]'" required v-if="!file.path">
                    <a v-if="file.path" :href="'/storage/' + file.path" target="_blank">{{ file.path }}</a>
                </td>
                <td>
                    <input type="text" class="form-control form-control-sm" placeholder="Nom du fichier" :name="'files[' + file.index + '][name]'" required v-model="file.name">
                </td>
                <td>
                    <button class="btn btn-sm btn-danger" @click="removeFile(index)" type="button">Supprimer</button>
                </td>
            </tr>
            </tbody>
        </table>
        <button class="btn btn-sm btn-secondary" @click="addFile(null)" type="button">Ajouter un fichier</button>
    </div>
</template>

<script>
    export default {
        name: "FilesManager",
        props: ['modelDocuments'],
        data() {
            return {
                count: 0,
                files: []
            }
        },
        methods : {
            addFile: function (file = null) {
                var data = {
                    id: '',
                    name: '',
                    path: '',
                    index: this.count
                }

                if (file != null) {
                    data.id = file.id
                    data.name = file.name
                    data.path = file.path
                }

                this.files.push(data)
                this.count ++
            },
            removeFile: function (index) {
                this.files.splice(index, 1)
            }
        },
        mounted(){
            const jsonLineBackup = JSON.parse(this.modelDocuments)
            if (Array.isArray(jsonLineBackup)) {
                if (jsonLineBackup.length > 0) {
                    jsonLineBackup.forEach(file => {
                        this.addFile(file)
                    })
                }
            }
        }
    }
</script>
